var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".SmallRemoveButton__removeButton__1AR-N{-ms-flex:none;flex:none;width:1.6em;height:1.6em;background:url(" + escape(require("assets/forms/delete.svg")) + ") no-repeat 50%;background-size:contain;cursor:pointer}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/controls/src/components/controls/SmallRemoveButton.scss"],"names":[],"mappings":"AAAA,wCACI,cAAU,AAAV,UAAU,AACV,YAAY,AACZ,aAAa,AAEb,uDAAyD,AACzD,wBAAwB,AAExB,cAAe,CAClB","file":"SmallRemoveButton.scss","sourcesContent":[".removeButton {\n    flex: none;\n    width: 1.6em;\n    height: 1.6em;\n\n    background: url(assets/forms/delete.svg) no-repeat center;\n    background-size: contain;\n\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"removeButton": "SmallRemoveButton__removeButton__1AR-N"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/SmallRemoveButton.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/SmallRemoveButton.scss
// module chunks = 0